import "./_style.css"
import {useContext, useEffect, useState} from "react";
import AuthContext from "../../context/AuthContext";
import {NavLink, useParams} from "react-router-dom";
import TopNavBar from "../../components/TopNavBar";
import BreadCrumbs from "../../components/BreadCrumbs";
import PaginationBar from "../../components/PaginationBar";
import Footer from "../../components/Footer";
import TemplatesFilterBlock from "./TemplatesFilterBlock";
import Button from "../../components/Button"


// Templates Grid Header
function TmplGridHeader() {
    return (
        <div className="grid-base grid-header template-grid-columns">
            <div>#</div>
            <div>Taxonomy Name</div>
            <div>Template Name</div>
        </div>
    )
}


function TmplGridRow(props: any) {

    const {num, tmplObj} = props

    let tmplURL:any = `../detail/${tmplObj.tmplUID}`

    return (
        <div className="grid-base grid-row  template-grid-columns">
            <div>{num}</div>
            <div>{tmplObj.taxName}</div>
            <div className="grid-row-itemlink">
                <NavLink to={tmplURL}>{tmplObj.tmplName}</NavLink>
            </div>
        </div>
    )
}

export default function TemplatesList() {

    let {userPermissions} = useContext(AuthContext)

    let {user, logoutUser, authTokens, serverIP} = useContext(AuthContext)

    const {page_num} = useParams()

    const crumbItems = [
        {'name': 'Main', 'link': '/'},
        {'name': 'Mapper Projects', 'link': '../../projects/1'},
        {'name': 'Templates', 'link': ''}
    ]

    const [filterObj, setFilterObj] = useState<any>({
        taxName: 'Icecat',
        tmplName: '',
    })
    // console.log('Filter object:', filterObj)

    const [pageData, setPageData] = useState<any>({
        firstPostIndx: 1,
        totalPosts: 0,
        dataList: []
    })

    const [queryObj, setQueryObj] = useState<any>({
        postsPerPage: 20,
        currentPage: isNaN(+(page_num || 1)) ? 1 : +(page_num || 1),
        filterObj: filterObj
    })

    useEffect(() => {
        getTmplData()
    }, [queryObj])


    let getTmplData = async () => {
        let response = await fetch(`${serverIP}/gettmplslist/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + String(authTokens.access)
            },
            body: JSON.stringify(queryObj),
        })
        let data = await response.json()

        if (response.status === 200) {
            // console.log(data)
            setPageData((prevState: any) => {
                return {
                    ...prevState,
                    firstPostIndx: data.firstPostIndx,
                    totalPosts: data.totalPosts,
                    dataList: data.pagePosts,
                    currentPage: data.currentPage
                }
            })
        } else if (response.statusText === 'Unauthorized') {
            logoutUser()
        }
    }

    const paginate = (pageNumber: number) => setQueryObj((prev: any) => {
        return {...prev, currentPage: pageNumber}
    });


    const rowElements = pageData.dataList.map((item: any, index: number) => {
        return <TmplGridRow
            key={index + pageData.firstPostIndx}
            num={index + 1 + pageData.firstPostIndx}
            tmplObj={item}
        />
    })


    return (

        <>

            <TopNavBar user={user} logoutUser={logoutUser} projName="Generic Templates" topNavItems={[]}/>
            <BreadCrumbs user={user} itemsLinks={crumbItems}/>

            <div className="tmpl-filter-add-container">
                <TemplatesFilterBlock
                    filterObj={filterObj}
                    setFilterObj={setFilterObj}
                    setQueryObj={setQueryObj}
                />

                <div className="tmpl-add-new">
                    {/*<NavLink to="../addnew">*/}
                    <NavLink to={userPermissions.canEdit ? "../detail/0" : ""}>
                        <Button type={userPermissions.canEdit ? "orange" : "secondary"} text="+ Add New"/>
                    </NavLink>
                </div>
            </div>

            <div className="count-and-paginator">
                <div style={{marginLeft: '10px'}}><small><i>Listing {pageData.totalPosts} items</i></small></div>

                <PaginationBar
                    postsPerPage={queryObj.postsPerPage}
                    totalPosts={pageData.totalPosts}
                    paginate={paginate}
                    currentPage={queryObj.currentPage}
                    parentURL={`../templates/`}
                />
            </div>

            <TmplGridHeader/>

            <div className="grid-rows-container">
                {rowElements}
                {/*<TmplGridRow/>*/}
            </div>

            <PaginationBar
                postsPerPage={queryObj.postsPerPage}
                totalPosts={pageData.totalPosts}
                paginate={paginate}
                currentPage={queryObj.currentPage}
                parentURL={`../templates/`}
            />

            <Footer/>

        </>
    )
}